import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";

import { XMLHttpRequestHandler } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import {accountingReport_template} from "../components/templates/accountingReport_template";
import { downloadCSV } from "../../vendor/valnet/valnet_jslib/vnHelpers/helper_functions";
import {header} from "./header";

declare var ko: any;
declare var page: any;

export class accounting_report extends vnModule_knockoutJS{

    protected XHRHdl: XMLHttpRequestHandler;
    protected elementsList: accountingReport_template;

    protected getModuleName(){
        return "accounting_report";
    }

    buildContent() : Array<Element>{
        this.elementsList = new accountingReport_template("list", this.viewModel, this);
        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("Accounting Report");
        return [this.elementsList.build()];
    }

    public fillPage() : void{
        this.filterList();
    }

    protected paginationOnPageClick(){
        this.filterList();
    }

    protected filterSimpleOnChange(){
        this.filterList();
    }

    protected filterSimpleCancel(){

    }

    protected paymentListReorder(){
        this.filterList();
    }

    protected filterList(){

        // LOADING : starts
        this.elementsList.builtTemplate.classList.add("loading");

        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }

        let subViewModel = {
            filterPayment: {
                payment: this.viewModel.list.idPayment
            }
        };
        let usrReq_url: string;
        if(this.getVnAppZone().app.params.idBrand != "VN") {
            usrReq_url = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/payment/accounting/report/';
        } else {
            usrReq_url = '/api/valnet/payment/accounting/report/';

        }
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)] );
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onFilterRequestReturn;
        this.XHRHdl.execute();

    }

    protected onFilterRequestReturn(req, obj){

        return function(){

            if (req.request.readyState == 4) {

                let responseParsed = JSON.parse(req.request.response);

                if(  req.request.status == 200  ){

                    obj.updateList(responseParsed.data);

                }
                else if (req.request.status == "423") {
                    obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, responseParsed.message);
                    obj.getVnAppZone().showNotificationToModule();
                    page.redirect('/' + obj.getVnAppZone().app.params.idBrand + '/home');
                }
                else{
                    //obj.onUpdateError(req.request.status, responseParsed);

                    obj.elementsList.validationsList.setSingleMessage({field: "error", label: req.request.status, message: responseParsed.message});
                    window.scrollTo(0, 0);
                }

                // LOADING : ends
                obj.elementsList.builtTemplate.classList.remove("loading");
            }
        }
    }

    //
    // update the module list using the objects list
    protected updateList(responseParsed){
        let huit_neuf_this = this.elementsList;
        let _this = this;

        if(responseParsed.totalCosts && responseParsed.totalCosts.length > 0){
            let totalCostCAD = 0;
            let totalCostUSD = 0;
            for (let item of responseParsed.totalCosts) {
                totalCostCAD += Number(item["totalCostsCAD"]);
                totalCostUSD += Number(item["totalCostsUSD"]);
                item["commissionCostCAD"] = '$' + Number(item["commissionCostCAD"]).toLocaleString(undefined, {minimumFractionDigits: 2});
                item["commissionCostUSD"] = '$' + Number(item["commissionCostUSD"]).toLocaleString(undefined, {minimumFractionDigits: 2})
                item["performanceCostCAD"] = '$' + Number(item["performanceCostCAD"]).toLocaleString(undefined, {minimumFractionDigits: 2})
                item["performanceCostUSD"] = '$' + Number(item["performanceCostUSD"]).toLocaleString(undefined, {minimumFractionDigits: 2})
                item["consultingBaseCostCAD"] = '$' + Number(item["consultingBaseCostCAD"]).toLocaleString(undefined, {minimumFractionDigits: 2})
                item["consultingBaseCostUSD"] = '$' + Number(item["consultingBaseCostUSD"]).toLocaleString(undefined, {minimumFractionDigits: 2})
                item["taxesCostCAD"] = '$' + Number(item["taxesCostCAD"]).toLocaleString(undefined, {minimumFractionDigits: 2})
                item["taxesCostUSD"] = '$' + Number(item["taxesCostUSD"]).toLocaleString(undefined, {minimumFractionDigits: 2})
                item["totalCostsCAD"] = '$' + Number(item["totalCostsCAD"]).toLocaleString(undefined, {minimumFractionDigits: 2})
                item["totalCostsUSD"] = '$' + Number(item["totalCostsUSD"]).toLocaleString(undefined, {minimumFractionDigits: 2})
                item["tipsCostCAD"] = '$' + Number(item["tipsCostCAD"]).toLocaleString(undefined, {minimumFractionDigits: 2})
                item["tipsCostUSD"] = '$' + Number(item["tipsCostUSD"]).toLocaleString(undefined, {minimumFractionDigits: 2})
                item["bonusCostCAD"] = '$' + Number(item["bonusCostCAD"]).toLocaleString(undefined, {minimumFractionDigits: 2})
                item["bonusCostUSD"] = '$' + Number(item["bonusCostUSD"]).toLocaleString(undefined, {minimumFractionDigits: 2})
                item["hostingCostCAD"] = '$' + Number(item["hostingCostCAD"]).toLocaleString(undefined, {minimumFractionDigits: 2})
                item["hostingCostUSD"] = '$' + Number(item["hostingCostUSD"]).toLocaleString(undefined, {minimumFractionDigits: 2})
                item["trainingCostCAD"] = '$' + Number(item["trainingCostCAD"]).toLocaleString(undefined, {minimumFractionDigits: 2})
                item["trainingCostUSD"] = '$' + Number(item["trainingCostUSD"]).toLocaleString(undefined, {minimumFractionDigits: 2})
                item["name"] = responseParsed.brand ? responseParsed.brand.name: 'Valnet';
            }
            this.elementsList.setBrandCosts(responseParsed.totalCosts);
            this.elementsList.setTotalCostCAD('$' + Number(totalCostCAD).toLocaleString(undefined, {minimumFractionDigits: 2}));
            this.elementsList.setTotalCostUSD('$' + Number(totalCostUSD).toLocaleString(undefined, {minimumFractionDigits: 2}));
        }

        this.elementsList.setBrand(responseParsed.brand);
        this.elementsList.setPayments(responseParsed.payments);
        this.elementsList.setAccounts(responseParsed.accounts);
        this.elementsList.setIdPayment(responseParsed.idPayment);
    }

    public exportToCSV(brandCosts: string[],totalCostCAD: string, totalCostUSD: string){
        let brandData = [];
        brandData.push({
            "Brand": "",
            "Total Cost": "CAD",
            " ":"USD",
            "Commission": "CAD",
            "  ":"USD",
            "Performance":"CAD",
            "    ":"USD",
            "Consulting Base":"CAD",
            "     ":"USD",
            "Bonuses":"CAD",
            "      ":"USD",
            "Tips":"CAD",
            "        ":"USD",
            "Hosting":"CAD",
            "       ":"USD",
            "Training":"CAD",
            "         ":"USD",
        });
        for (let item of brandCosts){
            brandData.push({
                "Brand": item["name"],
                "Total Cost": item["totalCostsCAD"],
                " ":item["totalCostsUSD"],
                "Commission": item["commissionCostCAD"],
                "  ":item["commissionCostUSD"],
                "Performance":item["performanceCostCAD"],
                "    ":item["performanceCostUSD"],
                "Consulting Base":item["consultingBaseCostCAD"],
                "     ":item["consultingBaseCostUSD"],
                "Bonuses":item["bonusCostCAD"],
                "      ":item["bonusCostUSD"],
                "Tips": item["tipsCostCAD"],
                "        ": item["tipsCostUSD"],
                "Hosting":item["hostingCostCAD"],
                "       ":item["hostingCostUSD"],
                "Training":item["trainingCostCAD"],
                "         ":item["trainingCostUSD"],
            });
        }
        //push empty row
        brandData.push({
            "Brand": "",
            "Total Cost": "",
            " ": "",
            "Commission": "",
            "  ": "",
            "Performance": "",
            "    ": "",
            "Consulting Base": "",
            "     ": "",
            "Bonuses": "",
            "      ": "",
            "Tips": "",
            "        ": "",
            "Hosting":"",
            "       ":"",
            "Training":"",
            "         ":"",
        });
        //Push Totals Row
        brandData.push({
            "Brand": "TOTALS",
            "Total Cost": totalCostCAD,
            " ": totalCostUSD,
            "Commission": "",
            "  ": "",
            "Performance": "",
            "   ": "",
            "Consulting Base": "",
            "    ": "",
            "Bonuses": "",
            "     ": "",
            "Tips": "",
            "      ": "",
            "Hosting":"",
            "       ":"",
            "Training":"",
            "         ":"",
        });
        downloadCSV({filename: "AccountingReport.csv", data: brandData});
        //tax report

        let taxData = [];
        let currentUser = null;
        let fullName = "";
        let province = "";
        let userTaxCodes = [];
        let taxTotal = 0;
    }

    private addTaxRow(fullName,taxTotal,province,taxCodes,userTaxCodes,csvData){
        let row = '{"Name": "'+fullName+'","Total Tax": "'+taxTotal+'","Province": "'+province+'"';
        for (let code of taxCodes){
            let userTaxCode = userTaxCodes.find(x => x.code == code);
            let userTaxNumber = userTaxCode != null ? userTaxCode.number : '';
            row += ',"'+code+'": "'+userTaxNumber+'"';
        }
        row += "}";
        csvData.push(JSON.parse(row));
    }


    protected onUpdateError(requestStatus: any, responseParsed) : void{
        let msg = "error: while obtaining the data - (" + requestStatus +")";
        this.viewModel.list.validationsList.setSingleMessage({field: "error", "label": requestStatus, message: msg});
        window.scrollTo(0, 0);
    }


}



// WEBPACK FOOTER //
// ./js/modules/accounting_report.ts